// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';

import config from 'config';

// Components
import { SignInModal } from 'src/components/SharedComponents/modal/signin-modal';
import { SearchInputContainer } from 'src/components/search/search-input-container';

export class HomepageBanner extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showSignInModal: false,
        };
    }

    // On Click Handlers
    openSignInModal() {
        mixpanelTracker.track(`${mixpanelTracker.signInClicked}`);
        this.setState({ showSignInModal: true });
    }

    closeSignInModal() {
        this.setState({ showSignInModal: false });
    }

    renderLogo() {
        return (<div className="homepage--banner-logo">
            <img alt="GoToStage.com Logo" className="homepage--banner-logo-img" src={`${config.assets.url}/images/shared-components/nav-bar/g2stage-logo-white.svg`} />
            <img alt="GoToStage.com Logo" className="homepage--banner-logo-img-mobile" src={`${config.assets.url}/images/shared-components/nav-bar/g2stage-logo-mobile.svg`} />
        </div>);
    }

    renderSearch() {
        if (!this.props.showSearch) {
            return null;
        }
        const searchProps = {
            desktopSearchIconClassNames: 'homepage--banner-search-icon',
            tabletSearchIconClassNames: 'homepage--banner-search-icon',
            mobileSearchIconClassNames: 'homepage--banner-search-icon-mobile',
            showSearchInputOverlay: this.props.showSearchInputOverlay
        };
        return (<div className="homepage--banner-search"><SearchInputContainer {...searchProps} /></div>);
    }

    renderSignIn() {
        // const {t} = this.props;
        // return (<span className="homepage--banner-signin">
        //     <a className="homepage--banner-signin-btn" onClick={this.openSignInModal.bind(this)}>
        //         <span>{t('navbar.signIn')}</span>
        //     </a>
        // </span>);
    }

    renderBanner() {
        const style = {
            backgroundImage: `url(${config.assets.url}/images/homePage/banner.svg)`
        };
        const {t} = this.props;
        return (
            <div className="homepage--banner" style={style}>
                <div className="homepage--banner-menu">
                    <div className="homepage--banner-menu-logo-search">
                        {this.renderLogo()}
                        {this.renderSearch()}
                    </div>
                {this.renderSignIn()}
                </div>
                <SignInModal show={this.state.showSignInModal} close={() => this.closeSignInModal()} t={t} />
            </div>
        );
    }


    render() {
        return this.renderBanner();
    }

}

HomepageBanner.propTypes = {
    t: PropTypes.func.isRequired,
    showSearchInputOverlay: PropTypes.func.isRequired,
    showSearch: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/home-page/banner/homepage-banner.js